export const formatPair = (pair) => {
    return pair.substring(0, pair.length - 4) + '/' + pair.substring(pair.length - 4, pair.length);
}

export const getPairCoinSymbol = (pair) => {
    return pair.substring(0, pair.length - 4).toLowerCase();
}